var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.ChromecastCAF = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.player.getCurrentTimeSec()
  },

  /** Override to return current playrate */
  getPlayrate: function () {
    return this.player.getPlaybackRate()
  },

  /** Override to return dropped frames since start */
  getDroppedFrames: function () {
    if (this.castMediaElement) {
      return this.castMediaElement.webkitDroppedFrameCount
    }
    return null
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.player.getDurationSec()
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    return this.bitrate || 0
  },

  /** Override to return user bandwidth throughput */
  getThroughput: function () {
    if (!this.throughput) {
      if (this.castMediaElement && this.castMediaElement.webkitVideoDecodedByteCount && this.castMediaElement.webkitAudioDecodedByteCount) {
        var prevCount = this.actualCount ? this.actualCount : 0
        this.actualCount = this.castMediaElement.webkitAudioDecodedByteCount + this.castMediaElement.webkitVideoDecodedByteCount
        return Math.round((this.actualCount - prevCount) / (this.plugin._ping.interval / 1000))
      }
    } else {
      return this.throughput
    }
    return -1
  },

  /** Override to return rendition */
  getRendition: function () {
    if (this.castMediaElement) {
      return youbora.Util.buildRenditionString(this.castMediaElement.videoWidth, this.castMediaElement.videoHeight, this.getBitrate())
    }
    return youbora.Util.buildRenditionString(this.getBitrate())
  },

  /** Override to return title */
  getTitle: function () {
    return this.player.getMediaInformation().metadata.title
  },

  /** Override to recurn true if live and false if VOD */
  getIsLive: function () {
    return this.getDuration() === -1
  },

  /** Override to return resource URL. */
  getResource: function () {
    return this.player.getMediaInformation().contentUrl || this.player.getMediaInformation().contentId
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    if (cast && cast.framework) {
      return cast.framework.VERSION
    }
    return null
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return "Chromecast"
  },

  /** Register listeners to this.player. */
  registerListeners: function () {

    this.castMediaElement = undefined
    for (var object in this.player) {
      if (typeof this.player[object] === "object") {
        for (var object2 in this.player[object]) {
          if (this.player[object][object2] && this.player[object][object2].id === "castMediaElement") {
            this.castMediaElement = this.player[object][object2]
          }
        }
      }
    }

    var Events = cast.framework.events

    var eCode = cast.framework.events.DetailedErrorCode

    // DetailedErrorCodes of the errors we dont want to report
    // https://developers.google.com/cast/docs/reference/caf_receiver/cast.framework.events#.DetailedErrorCode
    this.errorFilter = [
      eCode.MEDIAKEYS_UNKNOWN,
      eCode.MEDIAKEYS_NETWORK,
      eCode.MEDIAKEYS_UNSUPPORTED,
      eCode.MEDIAKEYS_WEBCRYPTO,
      eCode.SEGMENT_NETWORK,
      eCode.HLS_NETWORK_INVALID_SEGMENT,
      eCode.DASH_MANIFEST_NO_MIMETYPE,
      eCode.DASH_INVALID_SEGMENT_INFO,
      eCode.TEXT_UNKNOWN,
      eCode.SEGMENT_UNKNOWN,
      eCode.BREAK_SEEK_INTERCEPTOR_ERROR,
      eCode.APP,
      eCode.IMAGE_ERROR,
      eCode.LOAD_INTERRUPTED,
      eCode.MEDIA_ERROR_MESSAGE,
    ]

    // Console all events if logLevel=DEBUG
    youbora.Util.logAllEvents(this.player, [null,
      Events.EventType.PLAY,
      Events.EventType.PAUSE,
      Events.EventType.PLAYING,
      Events.EventType.STALLED,
      Events.EventType.SEEKING,
      Events.EventType.SEEKED,
      Events.EventType.ERROR,
      Events.EventType.CLIP_ENDED,
      Events.EventType.BITRATE_CHANGED,
      Events.EventType.SEGMENT_DOWNLOADED,
      Events.EventType.BUFFERING,
      Events.EventType.EMSG,
      Events.EventType.ID3,
      Events.EventType.MEDIA_FINISHED,
      Events.EventType.MEDIA_STATUS,
      Events.EventType.CACHE_HIT
    ])

    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, false)

    // Register listeners
    this.references = []
    this.references[Events.EventType.PLAY] = this.playListener.bind(this)
    this.references[Events.EventType.STALLED] = this.playListener.bind(this)
    this.references[Events.EventType.BUFFERING] = this.playListener.bind(this)
    this.references[Events.EventType.PAUSE] = this.pauseListener.bind(this)
    this.references[Events.EventType.PLAYING] = this.playingListener.bind(this)
    this.references[Events.EventType.SEEKING] = this.seekingListener.bind(this)
    this.references[Events.EventType.SEEKED] = this.seekedListener.bind(this)
    this.references[Events.EventType.CLIP_ENDED] = this.endedListener.bind(this)
    this.references[Events.EventType.ERROR] = this.errorListener.bind(this)
    this.references[Events.EventType.BITRATE_CHANGED] = this.bitrateChangedListener.bind(this)
    this.references[Events.EventType.SEGMENT_DOWNLOADED] = this.segmentListener.bind(this)

    for (var key in this.references) {
      this.player.addEventListener(key, this.references[key])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    if (this.monitor) this.monitor.stop()

    // unregister listeners
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.removeEventListener(key, this.references[key])
      }
      this.references = []
    }
  },

  /** Listener for 'play' event. */
  playListener: function (e) {
    this.fireStart()
  },

  /** Listener for 'pause' event. */
  pauseListener: function (e) {
    this.firePause()
  },

  /** Listener for 'playing' event. */
  playingListener: function (e) {
    this.fireResume()
    this.fireSeekEnd()
    this.fireBufferEnd()
    this.fireJoin()
  },

  /** Listener for 'error' event. */
  errorListener: function (e) {
    var error = e.error
    var code = e.detailedErrorCode
    if (this.errorFilter.indexOf(code) >= 0) {
      return  // if the code is in the filter list, skip it
    }
    if (error.type) error = error.type
    if (error && typeof error === "string") {
      this.fireError(code, error)
    } else {
      this.fireError(code)
    }
    if (error === "LOAD_CANCELLED") {
      this.fireStop() // EBVS
    }
  },

  /** Listener for 'seeking' event. */
  seekingListener: function (e) {
    this.fireSeekBegin()
  },

  /** Listener for 'seeked' event. */
  seekedListener: function (e) {
    this.fireSeekEnd()
    this.monitor.skipNextTick()
  },

  /** Listener for 'ended' event. */
  endedListener: function (e) {
    this.fireStop()
  },

  bitrateChangedListener: function (e) {
    this.bitrate = e.totalBitrate;
  },

  segmentListener: function (e) {
    this.throughput = e.size / (e.downloadTime / 1000) // bytes/s
  }
})

module.exports = youbora.adapters.ChromecastCAF
